import { Button, FormErrorMessage, Radio, RadioGroup, Spacer, Text, TextInput } from '@ksyos/design-system';
import type { IAltoStepProps } from '../../NewAltoDermaOthProcedure';
import { translateKey } from '../../../../../translate';
import { RadioGroupWrapper } from '../../../../elements/molecules/radioGroupWrapper/RadioGroupWrapper';
import { StyledFormGroup } from '../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function WhoAreYou(props: IAltoStepProps) {
    return (
        <>
            <Spacer
                direction="vertical"
                spacing="xlarge"
            >
                <Text size="xl">De huisarts heeft in Ksyos een vragenlijst klaargezet voor {props.csPatientName}.</Text>
                <StyledFormGroup
                    hasErrors={props.errors.has('isSomeoneElse')}
                    label="Wie ben je?"
                    layout="vertical"
                >
                    <RadioGroupWrapper>
                        <RadioGroup
                            name="isSomeoneElse"
                            onChange={(e) => {
                                const patientUpdate = { ...props.procedure.customControlData.patient };
                                if (e.target.value === 'true') {
                                    patientUpdate.isSomeoneElse = true;
                                } else {
                                    patientUpdate.isSomeoneElse = false;
                                    patientUpdate.someoneElseName = null;
                                }
                                props.handleChange({
                                    patient: {
                                        ...props.procedure.customControlData.patient,
                                        ...patientUpdate,
                                    },
                                });
                            }}
                            value={isSomeoneElse()}
                        >
                            <Radio
                                label={`Ik ben ${props.csPatientName} zelf`}
                                name="isSomeoneElse"
                                value={'false'}
                            ></Radio>
                            <Radio
                                label={`Ik ben iemand anders en vul het in voor ${props.csPatientName}`}
                                name="isSomeoneElse"
                                value={'true'}
                            ></Radio>
                        </RadioGroup>
                    </RadioGroupWrapper>

                    {props.procedure.customControlData.patient.isSomeoneElse && (
                        <StyledFormGroup
                            hasErrors={props.errors.has('someoneElseName')}
                            label="Wat is je naam?"
                            layout="vertical"
                        >
                            <TextInput
                                error={
                                    props.errors.get('someoneElseName')
                                        ? translateKey('validation.' + props.errors.get('someoneElseName'))
                                        : undefined
                                }
                                onChange={(e) =>
                                    props.handleChange({
                                        patient: {
                                            ...props.procedure.customControlData.patient,
                                            someoneElseName: e.target.value !== '' ? e.target.value : null,
                                        },
                                    })
                                }
                                onEnterKeyPress={props.validateAndGoToNextStep}
                                placeholder="Vul je naam in..."
                                value={props.procedure.customControlData.patient.someoneElseName || ''}
                            />
                        </StyledFormGroup>
                    )}
                    {props.errors.has('isSomeoneElse') && (
                        <FormErrorMessage>{translateKey('validation.any_selected')}</FormErrorMessage>
                    )}
                </StyledFormGroup>
            </Spacer>
            <Button
                color="secondary"
                onClick={props.validateAndGoToNextStep}
                variant="solid"
                width="full"
            >
                Verder
            </Button>
        </>
    );

    function isSomeoneElse() {
        if (props.procedure.customControlData.patient.isSomeoneElse === null) {
            return '';
        } else if (props.procedure.customControlData.patient.isSomeoneElse) {
            return 'true';
        }

        return 'false';
    }
}
